import { Modal } from 'antd';
import { Form, Field } from 'react-final-form';
import { required } from '../validations';

import {
  RenderAntInputTextField,
  RenderCheckboxField,
  RenderTextArea,
} from '../render-form-fields/RenderFormFields';

export const onInputNumberMaxLenCheck = (target, maxLen) => {
    if (target.value.length > maxLen) {
        // eslint-disable-next-line no-param-reassign
        target.value = target.value.slice(0, maxLen);
    }
};

export function UpdateMonthlyCompensationModal({
  newDesiredSalaryMonthly,
  salaryChangeReason,
  keepSalaryChangeFutureJobs,
  monthlyRateInUSD,
  onClose = () => null,
  onOK = () => null,
}) {
  const close = () => {
    onClose();
  };

  const onSubmit = (values) => {
    onOK({
      newDesiredSalaryMonthly: values.newDesiredSalaryMonthly,
      salaryChangeReason: values.salaryChangeReason,
      keepSalaryChangeFutureJobs: values.keepSalaryChangeFutureJobs,
    });
    close();
  };

  const initialValues = {
    newDesiredSalaryMonthly,
    salaryChangeReason,
    keepSalaryChangeFutureJobs,
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(values) => {
        onSubmit({ ...values, newDesiredSalaryMonthly: Number(values.newDesiredSalaryMonthly) });
      }}
      render={({ handleSubmit, hasValidationErrors }) => {
        return (
          <Modal
            className="update-monthly-compensation-modal"
            closable={false}
            centered
            open
            width={650}
            okText="Submit Rate Change Request"
            okButtonProps={{
              disabled: hasValidationErrors,
              'data-cy': 'update-monthly-compensation-modal__button-ok',
            }}
            onCancel={close}
            onOk={handleSubmit}
          >
            <div className="update-monthly-compensation-modal__container">
              <div className="update-monthly-compensation-modal__header">
                <div className="update-monthly-compensation-modal__header__maintext">
                  Update Monthly Expected Compensation
                </div>
                <div className="update-monthly-compensation-modal__header__subtext-old">
                  Your monthly compensation is currently set to{' '}
                  <strong>${monthlyRateInUSD}/month</strong> and we are considering you for the role
                  with this agreed rate. However, in case your expectations have changed, please
                  enter your new desired rate below.
                </div>
              </div>
              <div className="update-monthly-compensation-modal__body">
                <Field
                  className="gutter-bottom-sm"
                  name="newDesiredSalaryMonthly"
                  validate={required}
                >
                  {({ input, meta }) => (
                    <RenderAntInputTextField
                      type="number"
                      addonBefore="USD $ "
                      input={input}
                      meta={meta}
                      onInput={(e) => onInputNumberMaxLenCheck(e.target, 9)}
                    />
                  )}
                </Field>

                <Field className="gutter-bottom-sm" name="salaryChangeReason" validate={required}>
                  {({ input, meta }) => (
                    <RenderTextArea
                      rows={4}
                      size="large"
                      meta={meta}
                      input={input}
                      placeholder="Please provide a reason for the change."
                      maxLength={1000}
                    />
                  )}
                </Field>
                <Field
                  className="gutter-bottom-sm"
                  type="checkbox"
                  name="keepSalaryChangeFutureJobs"
                >
                  {({ input, meta }) => (
                    <RenderCheckboxField
                      title="I request this change for all jobs moving forward"
                      meta={meta}
                      input={input}
                      isInline
                      name="keepSalaryChangeFutureJobs"
                    />
                  )}
                </Field>
                <span className="update-monthly-compensation-modal__header__subtext-old">
                  Please note: Your rate won’t be applied automatically, and any rate updates aren’t
                  applicable to jobs where you are already interviewing with the client. We will log
                  your request and a member of our team will reach out to confirm if your desired
                  rate is within this client’s budget.
                </span>
              </div>
            </div>
          </Modal>
        );
      }}
    />
  );
}
